<div [class]="wrapperClasses">
  <div class="label-row" [class.sr-only]="hideLabel || inlineLabel">
    <label class="label" [id]="labelId" [for]="triggerId">
      {{ label }}
      @if (isRequired) {
        <span class="required-marker" aria-hidden="true"> *</span>
      }
    </label>
  </div>

  <button
    #triggerBtn
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    type="button"
    class="trigger"
    [id]="triggerId"
    [class.placeholder]="!selectedOption && !inlineLabel"
    [class.error]="hasError"
    [class.open]="isOpen"
    [disabled]="disabled"
    role="combobox"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="listboxId"
    [attr.aria-labelledby]="labelId + ' ' + triggerId"
    [attr.aria-invalid]="hasError ? 'true' : null"
    [attr.aria-required]="isRequired ? 'true' : null"
    [attr.aria-describedby]="describedBy"
    (click)="toggle()"
    (keydown)="onTriggerKeydown($event)"
  >
    @if (triggerIconSvg) {
      <span class="trigger-icon" aria-hidden="true" [innerHTML]="triggerIconSvg"></span>
    }
    <span class="trigger-text">{{ triggerText }}</span>
    <span class="trigger-chevron" aria-hidden="true" [innerHTML]="chevronSvg"></span>
  </button>

  @if (displayedSupportingText) {
    <span class="supporting-text" [class.supporting-text--error]="hasError" [id]="triggerId + '-supporting'">
      {{ displayedSupportingText }}
    </span>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayOutsideClick)="close()"
  (attach)="onPanelAttach()"
  (detach)="close()"
>
  @if (isOpen) {
    <ul
      #listboxEl
      cdkListbox
      class="panel"
      [class.sm]="size === 'sm'"
      [style.width.px]="overlayWidth"
      [id]="listboxId"
      [attr.aria-labelledby]="labelId"
      [cdkListboxValue]="listboxValue"
      (cdkListboxValueChange)="onListboxValueChange($event)"
      (keydown)="onListboxKeydown($event)"
    >
      @for (opt of options; track opt.value) {
        <li class="option" [class.error]="opt.error" [cdkOption]="opt.value" [cdkOptionDisabled]="!!opt.disabled">
          <span class="option-inner">
            @if (opt.iconSvg || opt.icon || optionsLeadingIcon) {
              <span class="option-icon" aria-hidden="true" [innerHTML]="optionIcon(opt)"></span>
            }
            <span class="option-text">
              <span class="option-label">{{ opt.label }}</span>
              @if (opt.supportingText) {
                <span class="option-support">{{ opt.supportingText }}</span>
              }
            </span>
          </span>
        </li>
      }
    </ul>
  }
</ng-template>
